import { Component } from '@angular/core';
import { ToasterConfig } from 'angular2-toaster/src/toaster-config';


@Component({
    selector: 'body',
    templateUrl: 'app.component.html'
})
export class AppComponent {

    public config: ToasterConfig = new ToasterConfig({ limit: 1, positionClass: 'toast-bottom-right' });

    constructor() {

    }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts